var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortoneLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 264,
    height: 68,
    viewBox: "0 0 264 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86071",
    "data-name": "Group 86071",
    transform: "translate(-1132 -171)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12868",
    "data-name": "Rectangle 12868",
    width: 264,
    height: 68,
    transform: "translate(1132 171)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_86070",
    "data-name": "Group 86070",
    transform: "translate(-2211 -2204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M147.667,37.175V30.268h-5.531s0,6.907,0,6.907c-.891.011-4.683,0-5.107,0-10.868,0-14.31,4.106-14.342,4.492.007-.077-.011-3.087-.011-4.489h-5.494V64.958h5.5l0-17.291a5.913,5.913,0,0,1,4.827-5.412,20.742,20.742,0,0,1,4.617-.582c3.762,0,6.245-.007,10.007-.009v12.4c0,3.615-.12,7.746,3.513,9.756a10.533,10.533,0,0,0,4.714,1.072c.351.016,6.084.1,6.084.063v-.009l5.374.009V60.421c-3.8,0-6.524.233-10.313-.032a4.173,4.173,0,0,1-2.988-1.285c-1.138-1.385-.855-3.619-.855-5.287V41.664h13.693l5.728-4.491H147.662Z",
    transform: "translate(3312.933 2363.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M76.793,40.692H75.507c-8.694,0-15.61,6.69-15.61,14.381s6.175,14.381,15.61,14.381h1.286c9.945,0,15.61-6.69,15.61-14.381S85.55,40.692,76.793,40.692ZM86.9,55.073C86.9,60.295,83.155,65,76.575,65h-.85A9.959,9.959,0,0,1,65.4,55.073,10.272,10.272,0,0,1,75.725,45.15h.85A10.244,10.244,0,0,1,86.9,55.073Z",
    transform: "translate(3334.964 2359.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M36.759,33.646c-.574-4.945-3.254-7.986-7.941-9.59a20.132,20.132,0,0,0-6.512-1.031H0V62.2H5.422V47.343H6.463c4.828,0,9.657.077,14.485.045a42.463,42.463,0,0,0,4.456-.263,15.084,15.084,0,0,0,5.764-1.813c4.131-2.323,6.186-6.545,5.592-11.664Zm-10.1,8.643a14.181,14.181,0,0,1-4.3.594c-5.258.091-10.88.036-16.14.034-.224,0-.449-.034-.719-.057V27.5h.789c5.286,0,10.932-.061,16.217.039a13.412,13.412,0,0,1,4.36.859,6.742,6.742,0,0,1,4.494,6.882c-.034,3.361-1.712,5.994-4.7,7.007Z",
    transform: "translate(3358 2366.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M304.329,47.311a10.085,10.085,0,0,0-3.952-4.122,12.454,12.454,0,0,0-6.045-1.532c-5.562,0-7.805,2.611-8.658,4.088V41.657h-5.5v27.67h5.5V53.681c0-3.571,2.807-7.714,6.979-7.714a7.48,7.48,0,0,1,5.669,2.189,9.19,9.19,0,0,1,1.916,6.241V69.327h5.5V53.55a13.185,13.185,0,0,0-1.406-6.241Z",
    transform: "translate(3250.247 2359.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M226.085,22.292H224.31c-12.007,0-21.56,9.223-21.56,20.042s8.531,20.042,21.56,20.042h1.775c13.737,0,21.56-9.223,21.56-20.042S238.183,22.292,226.085,22.292Zm-.594,35.628h-.585c-9.839,0-16.657-7.252-16.657-15.607s7.592-15.607,16.657-15.607h.585c9.134,0,16.657,7.252,16.657,15.607S235.863,57.92,225.491,57.92Z",
    transform: "translate(3280.024 2366.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M350.654,61.809a10.24,10.24,0,0,1-7.8,3.186h-.851a10,10,0,0,1-10.061-7.646h26.569a15.179,15.179,0,0,0,.172-2.28c0-7.689-6.853-14.381-15.61-14.381h-1.286c-8.694,0-15.61,6.69-15.61,14.381s6.174,14.381,15.61,14.381h1.286c6.839,0,11.655-3.164,14-7.641h-6.417Zm-8.648-16.663h.851a10.365,10.365,0,0,1,10.061,7.746h-20.97A10.4,10.4,0,0,1,342.006,45.146Z",
    transform: "translate(3232.552 2359.633)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortoneLight);
export default __webpack_public_path__ + "static/media/portone_light.a097c836ef15aee256fb6514dfff0763.svg";
export { ForwardRef as ReactComponent };